import * as React from 'react';
import { IconAvatar } from './IconAvatar';

export type NoUserAvatarProps = {
    identifier?:string,
    tooltip?:React.ReactNode,
    onClick?: (identifier:string) => void
};

export function NoUserAvatar (props: NoUserAvatarProps): JSX.Element
{
    return (
        <IconAvatar
            identifier={props.identifier || 'select_user'}
            icon='interface_user_user' 
            contentColor='#3d3737'
            backgroundColor='#eee8e8'
            size="32px"
            toolTip={props.tooltip}
            onClick={props.onClick}
        />
    );
}
